export const truncateString = (row: string, limit = 20) =>
{
    if (row.length > limit)
    {
        return row.substring(0, limit) + '...';
    }

    return row;
};
